const translations = {
    'config.error.buildings.required': 'wymagane są ustawienia buildings',
    'config.error.buildings.entry': 'buildings.%s musi być zdefiniowane',
    'config.error.buildings.cost.object': 'buildings.%s.cost musi być obiektem',
    'config.error.buildings.cost.value': 'buildings.%s.cost ma nieprawidłową wartość dla %s',
    'config.error.buildings.costScaling.required': 'buildings.%s.costScaling musi być zdefiniowane',
    'config.error.buildings.costScaling.a': 'buildings.%s.costScaling.a musi być >= 0',
    'config.error.buildings.costScaling.b': 'buildings.%s.costScaling.b musi być >= 0',
    'config.error.buildings.storage.max': 'buildings.%s.%s.%s.max musi być >= 0',
    'config.error.cost.object': 'koszt %s musi być obiektem',
    'config.error.cost.value': 'koszt %s ma nieprawidłową wartość dla %s',
    'config.error.costScaling.a': 'costScaling.%s.a musi być >= 0',
    'config.error.costScaling.b': 'costScaling.%s.b musi być >= 0',
    'config.error.costScaling.entry': 'costScaling.%s musi być zdefiniowane',
    'config.error.costScaling.required': 'wymagane jest costScaling',
    'config.error.construction.required': 'wymagane jest construction',
    'config.error.construction.refund.required': 'wymagane jest construction.refund',
    'config.error.construction.refund.percent': 'construction.refund.percent musi być 0-100',
    'config.error.construction.refund.allowInProgress':
        'construction.refund.allowInProgress musi być wartością logiczną',
    'config.error.defaults.populationPerHouse': 'defaults.populationPerHouse musi być > 0',
    'config.error.defaults.houseFoodTargetHours': 'defaults.houseFoodTargetHours musi być > 0',
    'config.error.defaults.houseHeatTargetHours': 'defaults.houseHeatTargetHours musi być > 0',
    'config.error.defaults.sawmillInputCap': 'defaults.sawmillInputCap musi być >= 0',
    'config.error.defaults.sawmillOutputCap': 'defaults.sawmillOutputCap musi być >= 0',
    'config.error.defaults.charcoalInputCap': 'defaults.charcoalInputCap musi być >= 0',
    'config.error.defaults.charcoalOutputCap': 'defaults.charcoalOutputCap musi być >= 0',
    'config.error.defaults.blacksmithInputCap': 'defaults.blacksmithInputCap musi być >= 0',
    'config.error.defaults.blacksmithOutputCap': 'defaults.blacksmithOutputCap musi być >= 0',
    'config.error.fish.regenRate': 'fish.regenRate musi być >= 0',
    'config.error.fish.required': 'wymagane jest fish',
    'config.error.heat.required': 'wymagane jest heat',
    'config.error.heat.coldInterval': 'heat.coldInterval musi być > 0',
    'config.error.heat.coldStep.required': 'wymagane jest heat.coldStep',
    'config.error.heat.coldStep.wooden': 'heat.coldStep.wooden musi być >= 0',
    'config.error.heat.coldStep.stone': 'heat.coldStep.stone musi być >= 0',
    'config.error.heat.warmInterval': 'heat.warmInterval musi być > 0',
    'config.error.heat.maxWarmth.required': 'wymagane jest heat.maxWarmth',
    'config.error.heat.maxWarmth.wooden': 'heat.maxWarmth.wooden musi być > 0',
    'config.error.heat.maxWarmth.stone': 'heat.maxWarmth.stone musi być > 0',
    'config.error.heat.warmth.required': 'wymagane jest heat.warmth',
    'config.error.heat.warmth.wood': 'heat.warmth.wood musi być > 0',
    'config.error.heat.warmth.charcoal': 'heat.warmth.charcoal musi być > 0',
    'config.error.initial.inventory': 'wymagane jest initial.inventory',
    'config.error.initial.inventory.bricks': 'initial.inventory.bricks musi być >= 0',
    'config.error.initial.inventory.charcoal': 'initial.inventory.charcoal musi być >= 0',
    'config.error.initial.inventory.clothRope': 'initial.inventory.clothRope musi być >= 0',
    'config.error.initial.inventory.coins': 'initial.inventory.coins musi być >= 0',
    'config.error.initial.inventory.fiber': 'initial.inventory.fiber musi być >= 0',
    'config.error.initial.inventory.fish': 'initial.inventory.fish musi być >= 0',
    'config.error.initial.inventory.food': 'initial.inventory.food musi być >= 0',
    'config.error.initial.inventory.goldOre': 'initial.inventory.goldOre musi być >= 0',
    'config.error.initial.inventory.ironIngots': 'initial.inventory.ironIngots musi być >= 0',
    'config.error.initial.inventory.ironOre': 'initial.inventory.ironOre musi być >= 0',
    'config.error.initial.inventory.leather': 'initial.inventory.leather musi być >= 0',
    'config.error.initial.inventory.planks': 'initial.inventory.planks musi być >= 0',
    'config.error.initial.inventory.stone': 'initial.inventory.stone musi być >= 0',
    'config.error.initial.inventory.tools': 'initial.inventory.tools musi być >= 0',
    'config.error.initial.inventory.weapons': 'initial.inventory.weapons musi być >= 0',
    'config.error.initial.inventory.wood': 'initial.inventory.wood musi być >= 0',
    'config.error.initial.required': 'wymagane jest initial',
    'config.error.initial.settlement': 'wymagane jest initial.settlement',
    'config.error.initial.settlement.buildings': 'wymagane jest initial.settlement.buildings',
    'config.error.initial.settlement.buildings.blacksmith.qty':
        'initial.settlement.buildings.blacksmith.qty musi być >= 0',
    'config.error.initial.settlement.buildings.charcoalPit.qty':
        'initial.settlement.buildings.charcoalPit.qty musi być >= 0',
    'config.error.initial.settlement.buildings.farm.qty':
        'initial.settlement.buildings.farm.qty musi być >= 0',
    'config.error.initial.settlement.buildings.fishingHut.qty':
        'initial.settlement.buildings.fishingHut.qty musi być >= 0',
    'config.error.initial.settlement.buildings.goldMine.qty':
        'initial.settlement.buildings.goldMine.qty musi być >= 0',
    'config.error.initial.settlement.buildings.houses':
        'initial.settlement.buildings.houses musi być >= 0',
    'config.error.initial.settlement.buildings.stoneHouse':
        'initial.settlement.buildings.stoneHouse musi być >= 0',
    'config.error.initial.settlement.buildings.huntingHut.qty':
        'initial.settlement.buildings.huntingHut.qty musi być >= 0',
    'config.error.initial.settlement.buildings.ironMine.qty':
        'initial.settlement.buildings.ironMine.qty musi być >= 0',
    'config.error.initial.settlement.buildings.lumberjack.qty':
        'initial.settlement.buildings.lumberjack.qty musi być >= 0',
    'config.error.initial.settlement.buildings.masonry.qty':
        'initial.settlement.buildings.masonry.qty musi być >= 0',
    'config.error.initial.settlement.buildings.mint.qty':
        'initial.settlement.buildings.mint.qty musi być >= 0',
    'config.error.initial.settlement.buildings.caravanPost.qty':
        'initial.settlement.buildings.caravanPost.qty musi być >= 0',
    'config.error.initial.settlement.buildings.stable.qty':
        'initial.settlement.buildings.stable.qty musi być >= 0',
    'config.error.initial.settlement.buildings.quarry.qty':
        'initial.settlement.buildings.quarry.qty musi być >= 0',
    'config.error.initial.settlement.buildings.sawmill.qty':
        'initial.settlement.buildings.sawmill.qty musi być >= 0',
    'config.error.initial.settlement.buildings.smelter.qty':
        'initial.settlement.buildings.smelter.qty musi być >= 0',
    'config.error.initial.settlement.buildings.smokehouse.qty':
        'initial.settlement.buildings.smokehouse.qty musi być >= 0',
    'config.error.initial.settlement.buildings.weaver.qty':
        'initial.settlement.buildings.weaver.qty musi być >= 0',
    'config.error.initial.settlement.population': 'initial.settlement.population musi być > 0',
    'config.error.initial.settlement.tier':
        'initial.settlement.tier musi być outpost, town lub city',
    'config.error.map.required': 'wymagane jest map',
    'config.error.map.size': 'map.size musi być "small", "medium" lub "huge"',
    'config.error.map.seed': 'map.seed musi być liczbą',
    'config.error.population.required': 'wymagane jest population',
    'config.error.population.hunger.required': 'wymagane jest population.hunger',
    'config.error.population.hunger.hungerInterval':
        'population.hunger.hungerInterval musi być > 0',
    'config.error.population.hunger.hungerStep': 'population.hunger.hungerStep musi być > 0',
    'config.error.population.hunger.maxHunger': 'population.hunger.maxHunger musi być > 0',
    'config.error.population.hunger.eatThreshold': 'population.hunger.eatThreshold musi być > 0',
    'config.error.population.hunger.foodStep': 'population.hunger.foodStep musi być > 0',
    'config.error.population.hunger.foodQty': 'population.hunger.foodQty musi być > 0',
    'config.error.population.warmth.required': 'wymagane jest population.warmth',
    'config.error.population.warmth.maxWarmth': 'population.warmth.maxWarmth musi być > 0',
    'config.error.population.warmth.coldInterval': 'population.warmth.coldInterval musi być > 0',
    'config.error.population.warmth.coldStep': 'population.warmth.coldStep musi być > 0',
    'config.error.population.warmth.warmthStep': 'population.warmth.warmthStep musi być > 0',
    'config.error.population.warmth.coldDebtThreshold':
        'population.warmth.coldDebtThreshold musi być >= 0',
    'config.error.production.blacksmith': 'wymagane jest production.blacksmith',
    'config.error.production.blacksmith.toolIngots':
        'production.blacksmith.toolIngots musi być > 0',
    'config.error.production.blacksmith.toolTicks': 'production.blacksmith.toolTicks musi być > 0',
    'config.error.production.blacksmith.toolWood': 'production.blacksmith.toolWood musi być > 0',
    'config.error.production.blacksmith.toolsPerBatch':
        'production.blacksmith.toolsPerBatch musi być > 0',
    'config.error.production.blacksmith.weaponIngots':
        'production.blacksmith.weaponIngots musi być > 0',
    'config.error.production.blacksmith.weaponLeather':
        'production.blacksmith.weaponLeather musi być > 0',
    'config.error.production.blacksmith.weaponTicks':
        'production.blacksmith.weaponTicks musi być > 0',
    'config.error.production.blacksmith.weaponWood':
        'production.blacksmith.weaponWood musi być > 0',
    'config.error.production.blacksmith.weaponsPerBatch':
        'production.blacksmith.weaponsPerBatch musi być > 0',
    'config.error.production.builderWorkPerTick': 'production.builderWorkPerTick musi być > 0',
    'config.error.production.charcoal': 'wymagane jest production.charcoal',
    'config.error.production.charcoal.ticksPerBatch':
        'production.charcoal.ticksPerBatch musi być > 0',
    'config.error.production.farm': 'wymagane jest production.farm',
    'config.error.production.farm.ticksPerFarmer': 'production.farm.ticksPerFarmer musi być > 0',
    'config.error.production.farm.toolUsage': 'production.farm.toolUsage musi być > 0',
    'config.error.production.fishing': 'wymagane jest production.fishing',
    'config.error.production.fishing.fishPerCatch': 'production.fishing.fishPerCatch musi być > 0',
    'config.error.production.fishing.ticksPerCatch':
        'production.fishing.ticksPerCatch musi być > 0',
    'config.error.production.forester': 'wymagane jest production.forester',
    'config.error.production.forester.ticksPerTree':
        'production.forester.ticksPerTree musi być > 0',
    'config.error.production.goldMine': 'wymagane jest production.goldMine',
    'config.error.production.goldMine.ticksPerOre': 'production.goldMine.ticksPerOre musi być > 0',
    'config.error.production.hunter': 'wymagane jest production.hunter',
    'config.error.production.hunter.foodPerWildLife':
        'production.hunter.foodPerWildLife musi być > 0',
    'config.error.production.hunter.leatherPerWildLife':
        'production.hunter.leatherPerWildLife musi być >= 0',
    'config.error.production.hunter.minHuntTicks': 'production.hunter.minHuntTicks musi być > 0',
    'config.error.production.hunter.ticksPerHuntRatio':
        'wymagane jest production.hunter.ticksPerHuntRatio',
    'config.error.production.hunter.ticksPerHuntRatio.ticks':
        'production.hunter.ticksPerHuntRatio.ticks musi być > 0',
    'config.error.production.hunter.ticksPerHuntRatio.wildLife':
        'production.hunter.ticksPerHuntRatio.wildLife musi być > 0',
    'config.error.production.hunter.toolUsage': 'production.hunter.toolUsage musi być > 0',
    'config.error.production.ironMine': 'wymagane jest production.ironMine',
    'config.error.production.ironMine.ticksPerOre': 'production.ironMine.ticksPerOre musi być > 0',
    'config.error.production.lumberWorkPerWood': 'production.lumberWorkPerWood musi być > 0',
    'config.error.production.masonry': 'wymagane jest production.masonry',
    'config.error.production.masonry.ticksPerBrick':
        'production.masonry.ticksPerBrick musi być > 0',
    'config.error.production.mint': 'wymagane jest production.mint',
    'config.error.production.mint.ticksPerBatch': 'production.mint.ticksPerBatch musi być > 0',
    'config.error.production.populationGrowthPerTick':
        'production.populationGrowthPerTick musi być >= 0',
    'config.error.production.quarry': 'wymagane jest production.quarry',
    'config.error.production.quarry.ticksPerStone': 'production.quarry.ticksPerStone musi być > 0',
    'config.error.production.sawmillWorkPerBatch': 'production.sawmillWorkPerBatch musi być > 0',
    'config.error.production.smelter': 'wymagane jest production.smelter',
    'config.error.production.smelter.charcoalPerBatch':
        'production.smelter.charcoalPerBatch musi być > 0',
    'config.error.production.smelter.ingotsPerBatch':
        'production.smelter.ingotsPerBatch musi być > 0',
    'config.error.production.smelter.orePerBatch': 'production.smelter.orePerBatch musi być > 0',
    'config.error.production.smelter.ticksPerBatch':
        'production.smelter.ticksPerBatch musi być > 0',
    'config.error.production.smokehouse': 'wymagane jest production.smokehouse',
    'config.error.production.smokehouse.fishPerBatch':
        'production.smokehouse.fishPerBatch musi być > 0',
    'config.error.production.smokehouse.foodPerBatch':
        'production.smokehouse.foodPerBatch musi być > 0',
    'config.error.production.smokehouse.ticksPerBatch':
        'production.smokehouse.ticksPerBatch musi być > 0',
    'config.error.production.weaver': 'wymagane jest production.weaver',
    'config.error.production.weaver.ticksPerBatch': 'production.weaver.ticksPerBatch musi być > 0',
    'config.error.time.campaignDays': 'time.campaignDays musi być > 0',
    'config.error.time.campaignTicks': 'time.campaignTicks musi być > 0',
    'config.error.audio.required': 'audio musi być zdefiniowane',
    'config.error.audio.entry': 'audio.%s musi być zdefiniowane',
    'config.error.audio.enabled': 'audio.%s.enabled musi być typu boolean',
    'config.error.audio.volume': 'audio.%s.volume musi być w zakresie 0-1',
    'config.error.time.required': 'wymagane jest time',
    'config.error.time.tickSeconds': 'time.tickSeconds musi być > 0',
    'config.error.time.ticksPerDay': 'time.ticksPerDay musi być > 0',
    'config.error.time.ticksPerHour': 'time.ticksPerHour musi być > 0',
    'config.error.time.ticksPerMinute': 'time.ticksPerMinute musi być > 0',
    'config.error.expedition.baseTicks': 'expedition.baseTicks musi być > 0',
    'config.error.expedition.banditLossRange':
        'expedition.encounters.banditLossRange musi być [min,max]',
    'config.error.expedition.encounters': 'wymagane jest expedition.encounters',
    'config.error.expedition.fatalFactions': 'expedition.encounters.fatalFactions musi być listą',
    'config.error.expedition.foodPerPopPerHex': 'expedition.foodPerPopPerHex musi być >= 0',
    'config.error.expedition.required': 'wymagane jest expedition',
    'config.error.expedition.stealAll': 'expedition.encounters.stealAll musi być boolean',
    'config.error.expedition.ticksPerHex': 'expedition.ticksPerHex musi być > 0',
    'config.error.expedition.toolsRequired': 'expedition.toolsRequired musi być >= 0',
    'config.error.alerts.required': 'wymagane jest alerts',
    'config.error.alerts.warningCooldownTicks': 'alerts.warningCooldownTicks musi być >= 0',
    'config.error.alerts.starvationHours': 'alerts.starvationHours musi być >= 0',
    'config.error.alerts.coldDebtRatio': 'alerts.coldDebtRatio musi być >= 0',
    'config.error.transport.baseTicks': 'transport.baseTicks musi być > 0',
    'config.error.transport.departureInterval': 'transport.departureInterval musi być > 0',
    'config.error.transport.required': 'wymagane jest transport',
    'config.error.transport.ticksPerHex': 'transport.ticksPerHex musi być > 0',
    'config.error.tool.initialDurability': 'tool.initialDurability musi być > 0',
    'config.error.tool.required': 'wymagane jest tool',
    'config.error.tree.ageInterval': 'tree.ageInterval musi być > 0',
    'config.error.tree.cutWorkBase': 'tree.cutWorkBase musi być > 0',
    'config.error.tree.cutWorkPerAge': 'tree.cutWorkPerAge musi być >= 0',
    'config.error.tree.maxAge': 'tree.maxAge musi być > 0',
    'config.error.tree.peakAge': 'tree.peakAge musi być pomiędzy 0 a maxAge',
    'config.error.tree.required': 'wymagane jest tree',
    'config.error.tree.reseedInterval': 'tree.reseedInterval musi być > 0',
    'config.error.tree.reseedRate': 'tree.reseedRate musi być >= 0',
    'config.error.tree.reseedThreshold': 'tree.reseedThreshold musi być pomiędzy 0 a 1',
    'config.error.tree.yieldAgeFactor': 'tree.yieldAgeFactor musi być >= 0',
    'config.error.tree.yieldBase': 'tree.yieldBase musi być > 0',
    'config.error.tree.yieldMinMultiplier': 'tree.yieldMinMultiplier musi być pomiędzy 0 a 1',
    'config.error.tree.yieldTailMultiplier': 'tree.yieldTailMultiplier musi być pomiędzy 0 a 1',
    'config.error.ui.language': 'ui.language musi być "en" lub "pl"',
    'config.error.ui.storageStatsMinutes': 'ui.storageStatsMinutes musi być dodatnią liczbą',
    'config.error.ui.required': 'wymagane jest ui',
    'config.error.wildLife.ageTicks': 'wildLife.ageTicks musi być > 0',
    'config.error.wildLife.baseMortalityPerAgeTick':
        'wildLife.baseMortalityPerAgeTick musi być pomiędzy 0 a 1',
    'config.error.wildLife.biomeCapWeight': 'wildLife.biomeCapWeight musi być pomiędzy 0 a 1',
    'config.error.wildLife.colonizeEmptyChance':
        'wildLife.colonizeEmptyChance musi być pomiędzy 0 a 1',
    'config.error.wildLife.colonizeEmptyMax':
        'wildLife.colonizeEmptyMax musi być >= colonizeEmptyMin',
    'config.error.wildLife.colonizeEmptyMin': 'wildLife.colonizeEmptyMin musi być >= 0',
    'config.error.wildLife.fecundityPerAdult': 'wildLife.fecundityPerAdult musi być >= 0',
    'config.error.wildLife.huntableAgeMin': 'wildLife.huntableAgeMin musi być >= 0',
    'config.error.wildLife.juvenileAgeEnd': 'wildLife.juvenileAgeEnd musi być >= 0',
    'config.error.wildLife.juvenileExtraMortality':
        'wildLife.juvenileExtraMortality musi być pomiędzy 0 a 1',
    'config.error.wildLife.matingAgeStart': 'wildLife.matingAgeStart musi być >= 0',
    'config.error.wildLife.matingInterval': 'wildLife.matingInterval musi być > 0',
    'config.error.wildLife.maxAge': 'wildLife.maxAge musi być > 0',
    'config.error.wildLife.migrationInterval': 'wildLife.migrationInterval musi być > 0',
    'config.error.wildLife.migrationRadius': 'wildLife.migrationRadius musi być >= 1',
    'config.error.wildLife.migrationRate': 'wildLife.migrationRate musi być > 0',
    'config.error.wildLife.newbornAge': 'wildLife.newbornAge musi być >= 0',
    'config.error.wildLife.overCapacityCullRate':
        'wildLife.overCapacityCullRate musi być pomiędzy 0 a 1',
    'config.error.wildLife.reproductionDensityPower':
        'wildLife.reproductionDensityPower musi być > 0',
    'config.error.wildLife.required': 'wymagane jest wildLife',
    'config.error.wildLife.senescentAgeStart': 'wildLife.senescentAgeStart musi być >= 0',
    'config.error.wildLife.senescentMortalitySlope':
        'wildLife.senescentMortalitySlope musi być >= 0',
    'config.error.wildLife.targetFill': 'wildLife.targetFill musi być pomiędzy 0 a 1',
    'config.error.wildLife.treesPerAnimal': 'wildLife.treesPerAnimal musi być > 0',
    'config.error.initial.settlement.buildings.barracks.qty':
        'initial.settlement.buildings.barracks.qty musi być >= 0',
    'config.error.scouting.required': 'wymagane jest scouting',
    'config.error.scouting.baseTicks': 'scouting.baseTicks musi być >= 0',
    'config.error.scouting.ticksPerHex': 'scouting.ticksPerHex musi być >= 0',
    'config.error.scouting.foodMultiplier': 'scouting.foodMultiplier musi być > 0',
    'config.error.scouting.foodStep': 'scouting.foodStep musi być > 0',
    'config.error.battle.required': 'wymagane jest battle',
    'config.error.battle.roundTicks': 'battle.roundTicks musi być > 0',
    'config.error.battle.unitsPerRound': 'battle.unitsPerRound musi być > 0',
    'config.error.battle.minRounds': 'battle.minRounds musi być > 0',
    'config.error.battle.maxRounds': 'battle.maxRounds musi być >= minRounds',
    'config.error.battle.rollRange': 'battle.rollMin/rollMax muszą być poprawne',
    'config.error.battle.encounterChance': 'battle.encounterChance musi być >= 0',
    'config.error.battle.encounterScaling': 'wymagane jest battle.encounterScaling',
    'config.error.battle.encounterScaling.countJitter':
        'battle.encounterScaling.countJitter musi być >= 0',
    'config.error.battle.encounterScaling.maxChance':
        'battle.encounterScaling.maxChance musi być >= minChance',
    'config.error.battle.encounterScaling.maxCountMultiplier':
        'battle.encounterScaling.maxCountMultiplier musi być >= minCountMultiplier',
    'config.error.battle.encounterScaling.maxDistance':
        'battle.encounterScaling.maxDistance musi być > 0',
    'config.error.battle.encounterScaling.minChance':
        'battle.encounterScaling.minChance musi być >= 0',
    'config.error.battle.encounterScaling.minCountMultiplier':
        'battle.encounterScaling.minCountMultiplier musi być > 0',
    'config.error.battle.units': 'battle.units musi być zdefiniowane',
    'config.error.battle.enemies': 'battle.enemies musi być zdefiniowane',
    'config.error.battle.unit.id': 'jednostka %s musi mieć id',
    'config.error.battle.unit.labelKey': 'jednostka %s musi mieć labelKey',
    'config.error.battle.unit.power': 'jednostka %s power musi być >= 0',
    'config.error.battle.unit.foodPerHex': 'jednostka %s foodPerHex musi być >= 0',
    'config.error.battle.unit.weaponCost': 'jednostka %s weaponCost musi być >= 0',
    'config.error.battle.enemy.weight': 'wróg %s weight musi być >= 0',
    'config.error.battle.enemy.countRange': 'wróg %s countRange musi być [min, max]',
};

export default translations;
